import React from 'react';
import PropTypes from 'prop-types';
import MessagePanel from './MessagePanel';//eslint-disable-line import/no-named-as-default
import * as appHelper from '../../helpers/appHelper';
import * as keyboardConstants from '../../constants/keyboardConstants';
import {TweenLite, Elastic, Bounce, Expo} from 'gsap';
import gsap from 'gsap-react-plugin';


export class TextInput extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            inFocus: false,

        };
        this.getWrapperClass = this.getWrapperClass.bind(this);
        this.onEnter = this.onEnter.bind(this);
        this.onFocusIn = this.onFocusIn.bind(this);
        this.onFocusOut = this.onFocusOut.bind(this);
        this.addFocusOutEffect = this.addFocusOutEffect.bind(this);
        this.onFocusOutComplete = this.onFocusOutComplete.bind(this);
        this.onRemove = this.onRemove.bind(this);
        this.onClickIcon = this.onClickIcon.bind(this);
        this.setOnClickIconKeyboardAccessibility = this.setOnClickIconKeyboardAccessibility.bind(this);
        this.setOnRemoveKeyboardAccessibility = this.setOnRemoveKeyboardAccessibility.bind(this);
    }

    getWrapperClass(){
        let wrapperClass = `form-group`;

        if(appHelper.isDefined(this.props.wrapperClassName)){
            wrapperClass += ` ${this.props.wrapperClassName}`;
        }

        if(this.state.inFocus){
            wrapperClass += ` active`;
        }

        if (this.props.error && this.props.error.length > 0) {
            wrapperClass += ` has-error`;
        }

        return wrapperClass;
    }

    onEnter(event){
        if(event.key === `Enter`){
            //this.addFocusOutEffect();
                           let inputRef = this.refs[`input_${this.props.name}`];
            if(appHelper.isDefined(inputRef)) {

                inputRef.blur();
            }
        }
    }

    onFocusIn(){
        this.setState({
            inFocus: true
        });
    }

    onFocusOut(){
        this.setState({
            inFocus: false
        });
        this.addFocusOutEffect();
    }

    addFocusOutEffect(){
        let inputRef = this.refs[`input_${this.props.name}`];
        if(appHelper.isDefined(inputRef)) {
            inputRef.classList.remove("focus-out");

            TweenLite.to(inputRef, 0.5, {
                css: {className: '+=focus-out'}
            }).eventCallback("onComplete", this.onFocusOutComplete);
        }
    }

    onFocusOutComplete(){
        let inputRef = this.refs[`input_${this.props.name}`];
        if(appHelper.isDefined(inputRef)) {
            inputRef.classList.remove("focus-out");
        }
    }

    onRemove(){
        this.props.onRemove();
    }

    onClickIcon(event){
        event.stopPropagation();
        this.props.onClickIcon();
    }
    setOnClickIconKeyboardAccessibility(event) {

        if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
            event.preventDefault();
            event.stopPropagation();
            this.onClickIcon();
        }
    }

    setOnRemoveKeyboardAccessibility(event) {

        if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
            event.preventDefault();
            event.stopPropagation();
            this.onRemove();
        }
    }
    render() {


        return (
            <div className={`${this.getWrapperClass()}`}>
                <div className="relative-input-wrapper">
                    <label htmlFor={this.props.name}>
                        <span>{this.props.label}</span>
                        {typeof this.props.onRemove !== 'undefined'
                            ?<span> | <div onClick={this.onRemove} onKeyDown={this.setOnRemoveKeyboardAccessibility} tabIndex="0" role="link">Remove</div></span>
                            :null
                        }
                        {typeof this.props.subLabel !== 'undefined'
                            ? <span className="sub-label"> - {this.props.subLabel}</span>
                            : null
                        }
                    </label>
                    <div className="field">
                        <input
                            type={this.props.type || 'text'}
                            name={this.props.name}
                            ref={`input_${this.props.name}`}
                            className={this.props.className + ' form-control'}
                            placeholder={this.props.placeholder}
                            value={this.props.value}
                            onChange={this.props.onChange}
                            onKeyPress={this.onEnter}
                            onFocus={this.onFocusIn}
                            onBlur={this.onFocusOut}
                            disabled = {(this.props.isDisabled)? "disabled" : ""}
                            maxLength={typeof this.props.maxLength !== 'undefined' ? this.props.maxLength : ''}

                        />
                        {typeof this.props.iconContainerClass !== 'undefined' &&typeof this.props.iconClass !== 'undefined' && typeof this.props.onClickIcon !== 'undefined'
                            ?<span className={`${this.props.iconContainerClass}`} onClick={this.onClickIcon} onKeyDown={this.setOnClickIconKeyboardAccessibility} tabIndex="0" role="link">
                                <span className={this.props.iconClass}/>
                            </span>
                            :null
                        }
                        {typeof this.props.messagePanelParams != 'undefined' && this.props.messagePanelParams.show
                            ?<MessagePanel name={this.props.name} message={this.props.messagePanelParams.message} alignment={this.props.messagePanelParams.alignment} show={this.props.messagePanelParams.show}/>
                            :null
                        }
                        {this.props.error && typeof this.props.hideErrorMessage === 'undefined' && <div className="alert alert-danger">{this.props.error}</div>}
                    </div>
                </div>
            </div>
        );
    }
}

TextInput.propTypes = {
    name: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    subLabel: PropTypes.string,
    wrapperClassName: PropTypes.string,
    className: PropTypes.string,
    placeholder: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    error: PropTypes.string,
    messagePanelParams: PropTypes.object,
    onRemove:PropTypes.func,
    hideErrorMessage:PropTypes.string,
    maxLength: PropTypes.string,
    type: PropTypes.string,
    iconContainerClass: PropTypes.string,
    iconClass: PropTypes.string,
    onClickIcon:PropTypes.func,
    isDisabled: PropTypes.bool,

};

//Pull in the React Router context so router is available on this.context.router.
TextInput.contextTypes = {
    router: PropTypes.object
};

//Init


export default TextInput;


/** WEBPACK FOOTER **
 ** ./src/components/form/TextInput.js
 **/